import {
  createApi,
  fetchBaseQuery,
  BaseQueryFn,
  FetchArgs,
  FetchBaseQueryError,
} from "@reduxjs/toolkit/query/react";
import Cookies from "js-cookie";
import { logout } from "../features/authSlice";

export const backEndBaseUrl = `${process.env.REACT_APP_SERVER_URL}`;

const baseQuery = fetchBaseQuery({
  baseUrl: backEndBaseUrl,
  prepareHeaders: (headers) => {
    const token = Cookies.get("token");
    if (token) headers.set("authorization", `${token}`);
    return headers;
  },
});

// Wrapper that handles 401 errors globally
const baseQueryWithReauth: BaseQueryFn<
  string | FetchArgs,
  unknown,
  FetchBaseQueryError
> = async (args, api, extraOptions) => {
  const result = await baseQuery(args, api, extraOptions);

  // If we get a 401, the token is invalid/expired - log out the user
  if (result.error?.status === 401) {
    api.dispatch(logout());
  }

  return result;
};

export const apiSlice = createApi({
  reducerPath: "api",
  tagTypes: [
    "service",
    "plan",
    "ChatList",
    "ApprenticeList",
    "blogs",
    "userProfile",
    "CountriesList",
    "StatesList",
    "CitiesList",
  ],
  baseQuery: baseQueryWithReauth,
  endpoints: () => ({}),
});
